<nz-page-header nzTitle="编辑用户信息">
  <!--  <nz-breadcrumb nz-page-header-breadcrumb>-->
  <!--    <nz-breadcrumb-item>首页</nz-breadcrumb-item>-->
  <!--    <nz-breadcrumb-item>用户管理</nz-breadcrumb-item>-->
  <!--    <nz-breadcrumb-item>编辑用户信息</nz-breadcrumb-item>-->
  <!--  </nz-breadcrumb>-->
  <!--   <nz-page-header-content>
  <input nz-input placeholder="输入关键字搜索用户" [(ngModel)]="name" style="width: 200px;">
  <button nz-button [nzType]="'primary'" class="ml-sm" (click)="searchName()">
    <span>搜索</span>
  </button>
</nz-page-header-content> -->
</nz-page-header>

<div class="p-md">
  <nz-card>
    <form nz-form [formGroup]="form">
      <!--账号-->
      <nz-form-item nz-row>
        <nz-form-label nz-col [nzSm]="6">账号</nz-form-label>
        <nz-form-control nz-col [nzSm]="14">
          <label>{{ teacher?.username | maskAccount }}</label>
        </nz-form-control>
      </nz-form-item>
      <!--真实姓名-->
      <nz-form-item nz-row>
        <nz-form-label nz-col [nzSm]="6">真实姓名</nz-form-label>
        <nz-form-control nz-col [nzSm]="14">
          <label>{{ teacher?.firstName }}</label>
        </nz-form-control>
      </nz-form-item>
      <!--新密码-->
      <nz-form-item nz-row>
        <nz-form-label nz-col [nzSm]="6">密码</nz-form-label>
        <nz-form-control nz-col [nzSm]="14">
          <span>*******</span>
        </nz-form-control>
      </nz-form-item>

      <!-- 教师权限 -->
      <nz-form-item nz-row>
        <nz-form-label nz-col [nzSm]="6">教师角色</nz-form-label>
        <nz-form-control nz-col [nzSm]="14">
          <label nz-checkbox formControlName="siteManager">分校管理员</label>
          <label nz-checkbox formControlName="gradeDirector">年级主任</label>
          <label nz-checkbox formControlName="subjectDirector">学科组长</label>
          <label nz-checkbox formControlName="classroomDirector">班主任</label>
        </nz-form-control>
      </nz-form-item>

      <!-- 管理年级 -->
      @if (form.get('gradeDirector').value || form.get('subjectDirector').value) {
        <nz-form-item nz-row>
          <nz-form-label nz-col nzRequired [nzSm]="6">管理年级</nz-form-label>
          <nz-form-control nz-col [nzSm]="10" nzHasFeedback [nzErrorTip]="manageGradeErrTpl">
            <nz-select
              nzShowSearch
              nzAllowClear
              nzMode="multiple"
              formControlName="manageGrade"
              nzPlaceHolder="请选择年级主任或者学科组长管理的年级"
            >
              @for (grade of gradeList; track grade) {
                <nz-option [nzLabel]="grade.name" [nzValue]="grade.id"></nz-option>
              }
            </nz-select>
            <ng-template #manageGradeErrTpl let-control>
              @if (form.controls['manageGrade'].hasError('required')) {
                <ng-container class="text-red"> 管理年级不能为空 </ng-container>
              }
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      }

      <!-- 管理班级 -->
      @if (form.get('classroomDirector').value) {
        <nz-form-item nz-row>
          <nz-form-label nz-col nzRequired [nzSm]="6">管理班级</nz-form-label>
          <nz-form-control nz-col [nzSm]="10" nzHasFeedback [nzErrorTip]="manageClassroomErrTpl">
            <nz-select
              nzShowSearch
              nzAllowClear
              nzMode="multiple"
              formControlName="manageClassroom"
              nzPlaceHolder="请选择班主任管理的班级"
            >
              @for (classroom of manageClassroomList; track classroom) {
                <nz-option [nzLabel]="classroom.text" [nzValue]="classroom.id"></nz-option>
              }
            </nz-select>
            <ng-template #manageClassroomErrTpl let-control>
              @if (form.controls['manageClassroom'].hasError('required')) {
                <ng-container class="text-red"> 管理班级不能为空 </ng-container>
              }
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      }

      <!-- 任教阶段 -->
      <nz-form-item>
        <nz-form-label nz-col [nzSm]="6">任教阶段</nz-form-label>
        <nz-form-control nz-col [nzSm]="6">
          <nz-select
            style="width: 160px"
            formControlName="userGrade"
            nzAllowClear
            [nzShowSearch]="true"
            nzPlaceHolder="尚未选择"
          >
            <nz-option nzLabel="小学" [nzValue]="0"></nz-option>
            <nz-option nzLabel="初中" [nzValue]="1"></nz-option>
            <nz-option nzLabel="高中" [nzValue]="2"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <!-- 任教科目 -->
      <nz-form-item nz-row>
        <nz-form-label nz-col nzRequired [nzSm]="6">任教科目</nz-form-label>
        <nz-form-control nz-col [nzSm]="6" nzHasFeedback [nzErrorTip]="subjectErrTpl">
          <nz-select
            style="width: 160px"
            formControlName="subject"
            nzPlaceHolder="尚未选择"
            [nzShowSearch]="true"
            nzAllowClear
          >
            @for (subject of subjectList; track subject) {
              <nz-option [nzLabel]="subject.name" [nzValue]="subject.id"> </nz-option>
            }
          </nz-select>
          <ng-template #subjectErrTpl>
            @if (form.controls['subject'].hasError('required')) {
              <ng-container class="text-red"> 任教科目不能为空 </ng-container>
            }
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- 任教班级 -->
      <nz-form-item nz-row>
        <nz-form-label nz-col [nzSm]="6">任教班级</nz-form-label>
        <nz-form-control [nzSm]="14">
          <nz-row nzAlign="middle">
            <nz-col class="mr-sm" nzSm="6">
              <nz-select nzShowSearch nzAllowClear formControlName="gradeList" nzPlaceHolder="请选择年级">
                @for (grade of gradeList; track grade) {
                  <nz-option [nzLabel]="grade.name" [nzValue]="grade.id"></nz-option>
                }
              </nz-select>
            </nz-col>
            <nz-col class="mr-sm" nzSm="6">
              <nz-select nzShowSearch formControlName="classType" nzPlaceHolder="请选择班级类型">
                <nz-option [nzValue]="0" nzLabel="行政班"></nz-option>
                <nz-option [nzValue]="1" nzLabel="教学班"></nz-option>
                <nz-option [nzValue]="2" nzLabel="靶向班"></nz-option>
              </nz-select>
            </nz-col>
            <nz-col class="mr-sm" nzSm="6">
              <nz-select nzShowSearch nzAllowClear formControlName="addClassId" nzPlaceHolder="请选择班级">
                @for (classroom of classroomList; track classroom) {
                  @if (classroom.type === form.get('classType').value) {
                    <nz-option [nzValue]="classroom.id" [nzLabel]="classroom.text"></nz-option>
                  }
                }
              </nz-select>
            </nz-col>
            <button
              nz-button
              nzType="default"
              [disabled]="!form.get('addClassId').value"
              (click)="addTeachClassroom(form.get('addClassId').value)"
            >
              添加
            </button>
          </nz-row>
          <nz-row nzAlign="middle">
            <nz-col class="ml-md">
              @for (classroom of form.get('teachClassroom').value; track classroom) {
                @if (classroom.type === 0) {
                  <a class="mr-sm" style="line-height: 40px"
                    >{{ classroom.name }}&nbsp;<i
                      (click)="deleteTeachClass(classroom.id)"
                      nz-icon
                      nzType="close"
                      nzTheme="outline"
                    ></i>
                  </a>
                }
              }
            </nz-col>
          </nz-row>
          <nz-row nzAlign="middle">
            <nz-col class="ml-md">
              @for (classroom of form.get('teachClassroom').value; track classroom) {
                @if (classroom.type === 1) {
                  <a class="mr-sm"
                    >{{ classroom.name }}&nbsp;<i
                      (click)="deleteTeachClass(classroom.id)"
                      nz-icon
                      nzType="close"
                      nzTheme="outline"
                    ></i>
                  </a>
                }
              }
            </nz-col>
          </nz-row>
          <nz-row nzAlign="middle">
            <nz-col class="ml-md">
              @for (classroom of form.get('teachClassroom').value; track classroom) {
                @if (classroom.type === 2) {
                  <a class="mr-sm"
                    >{{ classroom.name }}&nbsp;<i
                      (click)="deleteTeachClass(classroom.id)"
                      nz-icon
                      nzType="close"
                      nzTheme="outline"
                    ></i>
                  </a>
                }
              }
            </nz-col>
          </nz-row>
        </nz-form-control>
      </nz-form-item>

      <!--关联知识图谱权限-->
      <nz-form-item nz-row>
        <nz-form-label nz-col [nzSm]="6">关联知识图谱</nz-form-label>
        <nz-form-control nz-col [nzSpan]="14">
          <nz-switch formControlName="questionAssociateNode">
            <span checked>开</span>
            <span unchecked>关</span>
          </nz-switch>
        </nz-form-control>
      </nz-form-item>

      <!--禁用-->
      <nz-form-item nz-row>
        <nz-form-label nz-col [nzSm]="6">启用</nz-form-label>
        <nz-form-control nz-col [nzSpan]="14">
          <nz-switch formControlName="isActive">
            <span checked>开</span>
            <span unchecked>关</span>
          </nz-switch>
        </nz-form-control>
      </nz-form-item>

      <div nz-row>
        <div nz-col [nzSpan]="14" [nzOffset]="6">
          <a nz-button nzType="default" (click)="back()">取消</a>
          <button nz-button (click)="submit()" class="ml-sm" nzType="primary">确定</button>
        </div>
      </div>
    </form>
  </nz-card>
</div>
